<script>

export default {
  name: 'main-menu-item',
  props: [
    'menu'
  ],
  methods: {
    getRouteLabel (route) {
      if (this.isAuthenticated) {
        if (route.meta.labelProtected) {
          return route.meta.labelProtected
        }
      }
      if (!this.isAuthenticated) {
        if (route.meta.labelPublic) {
          return route.meta.labelPublic
        }
      }
      return route.meta.label
    },
    handleSelect (key, keyPath) {
    },
    handleMethod (methodName) {
      if (methodName) {
        this[ methodName ]()
      }
    }
  }
}
</script>

<template>
  <el-submenu
    v-if="menu.children"
    :index="menu.path"
    :router="false"
  >
    <template slot="title">
      <i
        :class="menu.meta.icon"
        v-if="menu.meta.icon"
      ></i>{{ getRouteLabel(menu) }}
    </template>
    <el-menu-item
      v-for="submenu in menu.children"
      @click="handleMethod(submenu.meta.click)"
      :index="submenu.path"
      :key="submenu.name"
      :router="true"
    >
      <i
        :class="submenu.meta.icon"
        v-if="submenu.meta.icon"
      ></i>
      {{ getRouteLabel(submenu) }}
    </el-menu-item>
  </el-submenu>
  <el-menu-item
    v-else
    :index="menu.path"
    :router="true"
  >
    <i
      :class="menu.meta.icon"
      v-if="menu.meta.icon"
    ></i>
    {{ getRouteLabel(menu) }}
  </el-menu-item>
</template>



// WEBPACK FOOTER //
// src/components/main-menu-item.vue